/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import Loader from "../../components/Loader/Loader";
import * as cms from "../../shared/repos/cms/cms";
import cmsKeys from "../../shared/constants/cms";

import styles from "./Contact.module.css";
import CmsInlineEdit from "../../components/Cms/CmsInlineEdit";
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import BrandRefreshFaq from '../SecondaryPages/BrandRefreshFaq';
import SecondaryPageEmpty from '../SecondaryPages/SecondaryPageEmpty';

const questionImage = require("./imgs/question-dark.png");
const plusCircleImage = require("./imgs/plus-circle.png");
const xCircleImage = require("./imgs/x-circle.png"); 

class FaqSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      loading: true,
      selectedTab: "",
      expandedQuestionId: null, // track which question is open
    };
  }

  componentDidMount() {
    cms.getContent([cmsKeys.faqPage.faqSections], this);
  }

  toggleQuestion = (id) => {
    this.setState((prev) => ({
      expandedQuestionId: prev.expandedQuestionId === id ? null : id,
    }));
  };

  render() {
    const { content, selectedTab, expandedQuestionId, loading } = this.state;

    if (isBrandRefreshEnabled()) {
      if (!content.length) {
        return loading ? <Loader id="loader" /> : <SecondaryPageEmpty />;
      }
      return <BrandRefreshFaq content={content} idPrefix="contact-faq" />;
    }

    if (!content.length) {
      return (
        <div className={styles.pageWrapper}>
          <div className={styles.pageContainer}>
            <Loader id="loader" />
          </div>
        </div>
      );
    }

    const activeSection =
      content.find((item) => item.cmsKeyId === selectedTab) || content[0];

    return (
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Left side tabs */}
        <div
          className="
            flex flex-row md:flex-col lg:flex-col 
            gap-4 
            w-[360px] lg:min-w-[260px] lg:w-auto
            overflow-x-auto md:overflow-visible
            scrollbar-hide
            [-ms-overflow-style:none] [scrollbar-width:none]
            mb-2 lg:mb-0
          "
        >
          {content.map((faqSection, index) => (
            <div
              key={faqSection.cmsKeyId}
              role="button"
              tabIndex="0"
              onKeyPress={(e) =>
                e.key === "Enter" &&
                this.setState({ selectedTab: faqSection.cmsKeyId })}
              onClick={() => this.setState({ selectedTab: faqSection.cmsKeyId })}
              className="flex-shrink-0 lg:flex text-center"
            >
              <div
                className={` ${
                  selectedTab === faqSection.cmsKeyId ||
                  (!selectedTab && index === 0)
                    ? "bg-dark text-white dark:bg-button dark:text-white font-bold"
                    : "text-dark font-medium"
                } px-3 py-3 font-montserratBold text-base leading-5 tracking-normal rounded-md whitespace-nowrap text-center`}
              >
                <CmsInlineEdit cmsNode={faqSection} type="list" showContent showChilds>
                  {faqSection.value}
                </CmsInlineEdit>
              </div>
            </div>
          ))}
        </div>


        {/* Right side FAQ list */}
        <div className="flex flex-col gap-4 w-full lg:w-[720px] mt-1 lg:mt-0">
          {activeSection?.children?.map((faqQuestion) => {
            const isOpen = expandedQuestionId === faqQuestion.cmsKeyId;
            const answerNode = faqQuestion.children?.[0];

            return (
              <div
                key={faqQuestion.cmsKeyId}
                className="w-full border border-[#E6DFE8] rounded-md transition-all duration-300"
              >
                <div
                  className="flex items-center justify-between px-4 py-2 cursor-pointer select-none"
                  onClick={() => this.toggleQuestion(faqQuestion.cmsKeyId)}
                  role="button"
                  tabIndex="0"
                  onKeyPress={(e) => e.key === 'Enter' && this.toggleQuestion(faqQuestion.cmsKeyId)}
                >
                  <h3 className="font-bold font-montserratBold leading-5 flex gap-4 items-center text-dark dark:text-light flex-1">
                    <img src={questionImage} alt="" className="flex-shrink-0" />
                    <CmsInlineEdit cmsNode={faqQuestion}>
                      {faqQuestion.value}
                    </CmsInlineEdit>
                  </h3>
                  <img
                    src={isOpen ? xCircleImage : plusCircleImage}
                    alt=""
                    className="transition-transform duration-300 flex-shrink-0"
                  />
                </div>

                <div
                  className={`overflow-hidden transition-[max-height,opacity] duration-500 ease-in-out ${
                    isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  {answerNode && (
                    <div className="px-4 pb-4 text-dark font-montserratBold text-base leading-5">
                      <CmsInlineEdit cmsNode={answerNode}>
                        {answerNode.value}
                      </CmsInlineEdit>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default FaqSection;
